import { SidebarMenuButton } from "@/components/ui/sidebar";
import { Route } from "@/types/general";
import { NavLink } from "react-router-dom";
import { sidebarNavState } from "@/features/report/v2/ReportKindDialog";

export default function NavLinkItem({ route }: { route: Route }) {
  const routeId = (route as any)?.stageId;

  return (
    <NavLink
      to={route.path}
      // "Report" opens the reports page, which then asks Standard vs Custom.
      state={sidebarNavState(route.path, { routeId })}
      style={{ cursor: "pointer !important" }}
      className="relative block"
    >
      {({ isActive }) => (
        <>
          {/* Left-side active indicator bar - full height, extends to sidebar edge */}
          {isActive && (
            <div
              className="absolute -left-4 top-0 bottom-0 w-[8px] rounded-tr-full rounded-br-full z-10"
              style={{ background: "var(--color-primary-gradient)" }}
            />
          )}
          <SidebarMenuButton
            isActive={isActive}
            className="justify-start transition-all duration-200 ease-linear w-full"
          >
            <route.icon />
            <span style={{ color: "var(--color-black-8)" }}>{route.label}</span>
          </SidebarMenuButton>
        </>
      )}
    </NavLink>
  );
}
